export default "__VITE_ASSET__d0d6f960__"